import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

export const Account: ImportTemplateField[] = [
  {
    toField: "accountKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "parentAccountKey",
    fromField: "",
    dataType: DataType.string,
    required: false,
  },
];
